import React, {useEffect, useState} from "react";
import NavLight from "../components/NavLight";

import "./Contact.css";
import {meta} from "../assets/meta/meta";
import {CustomMetaHelmet} from "../components/CustomMetaHelmet";
import MagicFeedback from "@magicfeedback/native";

function Contact() {
    const [loading, setLoading] = useState(true);
    // Initialize and render the MagicFeedback SDK
    useEffect(() => {
        MagicFeedback.init();

        const contactForm = MagicFeedback.form(
            "e7789130-d6e4-11ee-b5c3-af5aa6cf0f03",
            "28f10ab552b1f6f33ddfc90f73e0238a"
        );

        contactForm.generate("magicfeedback-contact-container", {
            addButton: true,
            sendButtonText: "Book a demo",
            addSuccessScreen: true,
            questionFormat: "slim",
            onLoadedEvent: () =>
                setLoading(false),
            beforeSubmitEvent: () => {
                const head = document.querySelector('head');
                const script = document.createElement('script');
                script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
                head.appendChild(script);
            },
            afterSubmitEvent: ({
                                   loading,
                                   progress,
                                   total,
                                   response, // Response of the server if everything is ok
                                   error, // Error of the server if something is wrong
                               }) => {
                if (error) {
                    // TODO: Show error message
                }
                const feedbackContainer = document.getElementsByClassName("magicfeedback-container");
                feedbackContainer[0].style.display = "none";

                const calendlyWidget = document.getElementsByClassName("calendly-inline-widget");
                calendlyWidget[0].style.display = "block";
            },
        });
    }, []);

    // Render the Contact component
    return (
        <div className="Contact">
            <CustomMetaHelmet meta={meta['schedule-demo']}/>
            <NavLight button={false}/>
            <section className="contact">
                <div className="contact-container">
                    <div className="contact-text">
                        <div className="contact-text-content">
                            <h1>Get in touch</h1>
                            <p>
                                Have all your questions answered by our experts.
                                <br/>
                                <br/>
                                Get a personal 30min demo on how Magic Feedback can help your company uncover deeper
                                insights at scale.
                                <br/>
                            </p>
                        </div>
                    </div>
                    <div className="contact-card">
                        <div className="contact-form-content">
                            <h1>Schedule your demo</h1>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                minHeight: "436px",
                            }}>
                                {loading && <span className="loader"/>}
                                <div id="magicfeedback-contact-container"/>
                                <div className="calendly-inline-widget"
                                     data-url="https://calendly.com/nimavr/user-interview?hide_gdpr_banner=1"
                                     style={{width: "100%", height: "65vh", display: 'none'}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
